import { del, get, post } from "../api"
import * as url from "./urls"

const getExportNotifications = userId => {
  const endpoint = url.CHECK_EXPORT_NOTIFICATIONS.replace(":userId", userId)
  return get(endpoint, {
    timeout: 30000,
    timeoutErrorMessage: "Reiniciar contagem",
  })
}

const checkCountCreated = () => {
  return get(url.CHECK_COUNT_CREATED, {
    timeout: 30000,
    timeoutErrorMessage: "Reiniciar contagem",
  })
}

const downloadFile = ({ filename, setProgress }) => {
  const endpoint = url.DOWNLOAD_FILE.replace(":filename", filename)
  return get(endpoint, {
    responseType: "blob",
    onDownloadProgress: progressEvent => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      setProgress(percentCompleted)
    },
  })
}

const downloadFileS3 = fileId => {
  const endpoint = url.DOWNLOAD_FILE_S3.replace(":id", fileId)
  return get(endpoint)
}

const getTemplates = () => {
  return get(url.GET_TEMPLATES)
}

const createTemplate = (name, tag, checkboxes, roleId, isNormalized) => {
  return post(url.POST_TEMPLATE, {
    name: name,
    alias: tag,
    checkboxes: checkboxes,
    roleId,
    isNormalized,
  })
}

const removeTemplate = id => {
  const endpoint = url.DELETE_TEMPLATE.replace(":id", id)
  return del(endpoint)
}

const getTemplateById = id => {
  const endpoint = url.GET_TEMPLATE_BY_ID.replace(":id", id)
  return get(endpoint)
}

const getTemplatesByRoleId = id => {
  const endpoint = url.GET_TEMPLATES_BY_ROLEID.replace(":id", id)
  return get(endpoint)
}

const updateTemplate = (id, name, tag, checkboxes, roleId, isNormalized) => {
  const endpoint = url.UPDATE_TEMPLATE.replace(":id", id)
  return post(endpoint, {
    name: name,
    alias: tag,
    checkboxes: checkboxes,
    roleId,
    isNormalized,
  })
}

export {
  getExportNotifications,
  downloadFile,
  downloadFileS3,
  getTemplates,
  createTemplate,
  removeTemplate,
  getTemplateById,
  getTemplatesByRoleId,
  updateTemplate,
}
